// extracted by mini-css-extract-plugin
export default {"container":"Boletim_container__gfmrx","errorContainer":"Boletim_errorContainer__H4kxD","errorBody":"Boletim_errorBody__on7Wt"};